import { Communicator } from './communicator';
import { Downloader } from './downloader';
import './main.scss';
import Dropdown from 'bootstrap/js/dist/dropdown';


if (window.location !== window.parent.location) {
    document.body.classList.add('embedded');
}

const communicator = new Communicator();

const dropdowns = document.querySelectorAll('.dropdown-toggle');
for (let i = 0; i < dropdowns.length; i++) {
    new Dropdown(dropdowns[i]);
}

// Accordion: toggle article detail rows and lazy-load content
let downloader: InstanceType<typeof Downloader> | null = null;
const downloadModal = document.querySelector<HTMLElement>('#download-details-modal');
if (downloadModal) {
    downloader = new Downloader(document.querySelectorAll('a.download-button'), downloadModal);
}

document.querySelectorAll<HTMLTableRowElement>('tr.has-accordion').forEach((row) => {
    row.addEventListener('click', async (e) => {
        if ((e.target as HTMLElement).closest('a')) return;
        const detailRow = row.nextElementSibling as HTMLElement | null;
        if (!detailRow || !detailRow.classList.contains('article-detail-row')) return;

        const isOpen = detailRow.style.display !== 'none';

        detailRow.style.display = isOpen ? 'none' : '';
        const chevron = row.querySelector<HTMLElement>('.details-chevron');
        if (chevron) {
            chevron.classList.toggle('open', !isOpen);
        }

        if (!isOpen && !detailRow.dataset.loaded) {
            const article = detailRow.dataset.article ?? '';
            const lang    = detailRow.dataset.lang    ?? 'de';
            const td      = detailRow.querySelector('td');
            const tpl = document.querySelector<HTMLTemplateElement>('#busy-indicator');
            const spinnerTimer = tpl && td ? window.setTimeout(() => {
                td.appendChild(tpl.content.cloneNode(true));
            }, 800) : null;
            try {
                const url = `product-accessoire.php?article=${encodeURIComponent(article)}&language=${encodeURIComponent(lang)}`;
                const response = await fetch(url, { credentials: 'same-origin' });
                if (spinnerTimer !== null) { clearTimeout(spinnerTimer); }
                if (response.ok && td) {
                    td.innerHTML = await response.text();
                    detailRow.dataset.loaded = '1';
                    if (downloader) {
                        downloader.bindButtons(td.querySelectorAll('a.download-button'));
                    }
                }
            } catch {
                if (spinnerTimer !== null) { clearTimeout(spinnerTimer); }
                // ignore network errors – leave spinner in place
            }
        }
    });
});

document.querySelectorAll<HTMLFormElement>('.search-form').forEach((searchForm) => {
    searchForm.querySelectorAll<HTMLSelectElement>('select').forEach((select) => {
        select.addEventListener('change', () => {
            //disable all other fields if the search form is a single search form
            if (searchForm.classList.contains('single')) {
                searchForm.querySelectorAll('input,select').forEach((input) => {
                    if (
                        (input instanceof HTMLSelectElement && input !== select) ||
                        (input instanceof HTMLInputElement && input.type !== 'hidden')
                    ) {
                        input.value = '';
                    }
                });
            }
            
            searchForm.submit();
        });
    });
    
    if (searchForm.classList.contains('single')) {
        searchForm.querySelectorAll<HTMLInputElement>('input[type="text"]').forEach((input) => {
            input.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    searchForm.querySelectorAll('select,input[type="hidden"]').forEach((select) => {
                        (select as HTMLInputElement | HTMLSelectElement).value = '';
                    });
                }
            });
        });
    }
});
    

const refreshMarginTop = () => {
    document.querySelectorAll('.position-sticky').forEach((element) => {
        if (element instanceof HTMLElement) {
            const bounds = element.getBoundingClientRect();
            element.style.setProperty('--margin-top', bounds.top + 'px');
        }
    });
};

window.addEventListener('resize', refreshMarginTop);

const onDOMContentLoaded = async () => {
    await communicator.waitForReady();
    communicator.sendNavigate();
    refreshMarginTop();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
} else {
    onDOMContentLoaded();
}